(function (ResearchList, $, window, document) {
  'use strict';
  //## GENERAL Scripts
  var generalScripts = (function () {
    var GLOBS = {
      $body: $('body'),
      $doc: $(document),
      loader: document.getElementById('loader'),
      visibleClass: 'is--visible',
      activeClass: 'is--active',
    };
    //Binds all handle functions to a new function which is called @init
    var bindEvents = function () {
      function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
      var newsList = [];
      //Default Rest
      var perPage = 15,
        page = 1,
        sort = 'year_published desc',
        cat = 'ARTICLE';
      //Clear Html
      function clearresearchHtml() {
        $('.research-article').remove();
      }
      String.prototype.trimEllip = function (length) {
        return this.length > length ? this.substring(0, length) + '...' : this;
      };
      //*RENDER
      function renderResearchList(news) {
        var researchHtml = '';
        news.forEach(function (article) {
          newsList.push(article);

          var url = singleResearchUrl + '?researchid=' + article.cristin_result_id;
          researchHtml += "<article class='research-article' id='" + article.cristin_result_id + "'>";
          researchHtml += "  <a href='" + url + "'>";
          if (article.title) {
            var title;
            if (article.title.en) {
              title = article.title.en;
            } else {
              title = Object.values(article.title)[0];
            }
            researchHtml += "    <h3 class='research-article__title'>" + title + '</h3>';
          }
          if (article.contributors) {
            var authorList = article.contributors.preview;
            researchHtml += "    <div class='research-article__authors'>";

            authorList.forEach(function (author) {
              researchHtml += '      <span>' + author.first_name + ' ' + author.surname + '</span>';
            });
            researchHtml += '    </div>';
          }
          /*  if (article.summary) {
            var excerpt = article.summary.en ? article.summary.en : article.summary.no;
            researchHtml += "    <p class='research-article__excerpt'>" + excerpt + "</p>";
          } */
          if (article.year_published) {
            researchHtml += "  <span class='research-article__date'>Published: " + article.year_published + '</span>';
          }
          researchHtml += '  </a>';
          researchHtml += "  <a href='" + url + "' class='research-article__readmore'>Read the summary</a>";
          researchHtml += '</article>';
        });
        $('#loader').hide();

        document.getElementById('ajax-research-selected').innerHTML += researchHtml;
      }
      //* FETCH
      var totalItems;
      function fetchSelectedArticles(page, perPage, sort) {
        selectedResearch.forEach(function (selected) {
          $('#loader').show();
          var data = {};
          data['page'] = page;
          data['per_page'] = 1;
          data['fields'] = 'all';
          data['id'] = selected;
          data['lang'] = 'en';
          data['sort'] = sort;
          axios
            .get('https://api.cristin.no/v2/results', {
              params: data,
            })
            .then(function (response) {
              var totalItems = response.headers && response.headers['x-total-count'];
              if (page == 1) {
                $('#prev-page').hide();
              } else {
                $('#prev-page').show();
              }
              if (perPage >= totalItems) {
                $(' #next-page').hide();
              } else {
                $(' #next-page').show();
              }

              if (response.data.length == 0) {
                $(' #next-page').hide();
                $('#notfoundtext').show();
              } else {
                $('#notfoundtext').hide();
              }
              if (response.data.length < perPage) {
                $(' #next-page').hide();
              } else {
                $(' #next-page').show();
              }
              renderResearchList(response.data);
            })
            .catch(function (error) {
              console.error(error);
              $('#loader').hide();
            });
        });
      }
      //Default
      if (document.getElementById('ajax-research-selected')) {
        fetchSelectedArticles(page, perPage, sort);
      }
      $('#load-more').click(function (e) {
        page++;
        fetchSelectedArticles(page, perPage, sort);
      });
      $('#sort-cbox').click(function () {
        if (!$(this).is(':checked')) {
          clearresearchHtml();
          $(this).parent().find('label span').html('Date (oldest to lastest)');
          sort = 'year_published asc';
          fetchSelectedArticles(page, perPage, sort);
        } else {
          clearresearchHtml();
          sort = 'year_published desc';
          fetchSelectedArticles(page, perPage, sort);
          $(this).parent().find('label span').html('Date (lastest to oldest)');
        }
      });
    };
    //End BIND
    //Inits Functions and Events
    var init = function () {
      bindEvents();
    };
    //END INIT
    //Inits Plugins
    var initPlugins = function () {};
    //END INIT PLUGINS
    return {
      init: init,
      initPlugins: initPlugins,
    };
  })();
  //## END GENERAL Scripts
  //## ResearchList MAIN
  var ResearchListMain = (function () {
    var init = function () {
      generalScripts.init();
      generalScripts.initPlugins();
    };
    return {
      init: init,
    };
  })();
  //## END ResearchList MAIN
  //Doc Ready
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      ResearchListMain.init();
    },
    false
  );
})((window.ResearchList = window.ResearchList || {}), window.jQuery, window, document);
